import { createFileRoute } from '@tanstack/react-router';

import { ManufacturingAppTabLayout } from '@/areas/manufacturing-templates/common/CostingTemplates/ManufacturingAppTabLayout';
import { MANUFACTURING_APP_TABS_SLOT } from '@/areas/manufacturing-templates/common/CostingTemplates/ManufacturingDatabaseTabs';
import { canViewManufacturing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { AppTabRoute } from '@/shared/routing/appTabs';

export const Route = createFileRoute('/_authenticated/manufacturing/_sidebar/apps/$appId/$widgetId')({
    staticData: { access: { permissions: canViewManufacturing }, chrome: 'home' } satisfies PageStaticData,
    component: () => <AppTabRoute slotId={MANUFACTURING_APP_TABS_SLOT} layout={ManufacturingAppTabLayout} />,
});
